export default function slideLeftAnimation() {
    return {
        addClass: (element, className, done) => {
            element.addClass('animated bounceInLeft').show()
                .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
                    element.removeClass('bounceInLeft');
                    done()
                })
        },

        removeClass: (element, className, done) => {
            element.addClass('animated bounceOutLeft')
                .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
                    element.hide().removeClass('bounceOutLeft');
                    done()
                })
        }
    }
};
